const smartScreenContent = resolve => require(['@/pages/smartScreen/smartScreenContent/index.vue'], resolve)
const smartScreenManage = resolve => require(['@/pages/smartScreen/smartScreenManage/index.vue'], resolve)
const smartScreen = resolve => require(['@/pages/smartScreen/smartScreenManage/main.vue'], resolve)
const mainDetails = resolve => require(['@/pages/smartScreen/smartScreenContent/main/index.vue'], resolve)
const advertisement = resolve => require(['@/pages/smartScreen/smartScreenContent/advertisement/index.vue'], resolve)
const notice = resolve => require(['@/pages/smartScreen/smartScreenContent/notice/index.vue'], resolve)
const advertiseCreated = resolve => require(['@/pages/smartScreen/smartScreenContent/advertisement/create/index.vue'], resolve)
const noticeCreated = resolve => require(['@/pages/smartScreen/smartScreenContent/notice/create/index.vue'], resolve)
const mainCreated = resolve => require(['@/pages/smartScreen/smartScreenContent/main/create/index.vue'], resolve)
const advertiseFinish = resolve => require(['@/pages/smartScreen/smartScreenContent/advertisement/create/finish.vue'], resolve)
const noticeFinish = resolve => require(['@/pages/smartScreen/smartScreenContent/notice/create/finish.vue'], resolve)
const mainFinish = resolve => require(['@/pages/smartScreen/smartScreenContent/main/create/finish.vue'], resolve)
const mainSet = resolve => require(['@/pages/smartScreen/smartScreenContent/main/create/mainSet.vue'], resolve)
const mainDetail = resolve => require(['@/pages/smartScreen/smartScreenContent/details/mainDetail.vue'], resolve)
const noticeDetail = resolve => require(['@/pages/smartScreen/smartScreenContent/details/noticeDetail.vue'], resolve)
const advertisementDetail = resolve => require(['@/pages/smartScreen/smartScreenContent/details/advertisementDetail.vue'], resolve)
export default[
    //智能屏管理
    {
      path: "/smartScreenContent",
      name: "屏幕放映内容",
      component: smartScreenContent
    },
    {
      path: "/smartScreen",
      name: "屏幕管理",
      component: smartScreen
    },
    {
      path: "/smartScreen/Main",
      name: "屏幕管理",
      component: smartScreenManage
    },
    {
      path: "/smartScreenContent/mainDetails",
      name: "主要放映区",
      component: mainDetails
    },
    {
      path: "/smartScreenContent/advertisement",
      component: advertisement
    },
    {
      path: "/smartScreenContent/notice",
      component: notice
    },
    {
      path:"/smartScreenContent/advertiseCreated",
      component: advertiseCreated
    },
    {
      path:"/smartScreenContent/noticeCreated",
      component: noticeCreated
    },
    {
      path:"/smartScreenContent/mainCreated",
      component: mainCreated
    },
    {
      path:"/smartScreenContent/advertiseFinish",
      component: advertiseFinish
    },
    {
      path:"/smartScreenContent/noticeFinish",
      component: noticeFinish
    },
    {
      path:"/smartScreenContent/mainFinish",
      component: mainFinish
    },
    {
      path:"/smartScreenContent/mainSet",
      component: mainSet
    },
    {
      path:"/smartScreenContent/mainDetail",
      component: mainDetail
    },
    {
      path:"/smartScreenContent/noticeDetail",
      component: noticeDetail
    },
    {
      path:"/smartScreenContent/advertisementDetail",
      component: advertisementDetail
    }
]